import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class DeviceTypeFormatter extends Formatter {
}

// Типы устройств (CRUD authorized/admin/device-types).
export default class ApiDeviceType extends ApiModelWithAuth {
    pathDef = 'authorized/admin/device-types';
    formatterItem = DeviceTypeFormatter.Item;
}
